import React from "react";
import ProductTestimonial from "./productTestimonial/ProductTestimonial";
import Innovation from "./innovation/Innovation";
import Launch from "./launch/Launch";
import Deliver from "./deliver/Deliver";
import ProductHero from "./producthero/ProductHero";
import Trusted from "./trusted/Trusted";
import Services from "./serviceproduct/Services";


export default function ProductPage() {
  return (
    <div id="productpage">
        <ProductHero/>
        <Deliver/>
        <Trusted/>
        <Launch/>
        <Innovation/>
      <ProductTestimonial />
      <Services/>
    </div>
  );
}
